import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';

import {
  ContentWrapper,
  ReadMoreWrapper,
  ReadMoreLinksWrapper,
  ReadMoreLink,
  ReadMoreTitle,
} from '../styles';

import { OverviewCTALinkWrapper } from '@/src/components/OverviewSection';
import { fieldHasContent } from '@/src/domains/prismic/helpers';

export function ReadMore({ title, image, links }) {
  return (
    <ReadMoreWrapper>
      {image && <Image src={image.url} alt={image.alt || ''} {...image.dimensions} />}
      <ContentWrapper>
        <ReadMoreTitle>{fieldHasContent(title) && <PrismicRichText field={title} />}</ReadMoreTitle>

        {links?.map(
          ({ label, link }, index) =>
            link?.url && (
              <ReadMoreLinksWrapper key={index}>
                <OverviewCTALinkWrapper>
                  <ReadMoreLink href={link.url} rel="noreferrer noopener" target="_blank">
                    {label}
                  </ReadMoreLink>
                </OverviewCTALinkWrapper>
              </ReadMoreLinksWrapper>
            )
        )}
      </ContentWrapper>
    </ReadMoreWrapper>
  );
}
